import { Flex, Typography, Card } from "antd";
import Chart from "react-apexcharts";
import React from "react";

export default function TreatmentCorrelations() {
  return (
    <Card style={{ minWidth: 351, height: 350 }}>
      <Flex vertical>
        <Typography.Title level={4}>Treatment Correlations</Typography.Title>
        <TreatmentCorrelationsChart />
      </Flex>
    </Card>
  );
}

const TreatmentCorrelationsChart = () => {
  // Only ONE series → one bar per month
  const series = [
    {
      name: "Correlation",
      data: [30, 45, 60, 80, 75, 90],
    },
  ];

  const options = {
    chart: {
      type: "bar",
      height: 200,
      toolbar: { show: false },
      zoom: { enabled: false },
      parentHeightOffset: 0, // Critical for removing bottom gap
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "26%",
        borderRadius: 6,
        endingShape: "rounded",
        distributed: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 1,
      colors: ["transparent"],
    },
    colors: ["#722ed1"], // Solid purple
    xaxis: {
      categories: ["Scolling", "Root Planing", "Root Planing", "Root Planing", "Root Planing", "Root Planing"],
      labels: {
        rotate: -45,
        rotateAlways: true,
        style: {
          fontSize: "12px",
          fontWeight: 500,
          colors: "#979797",
        },
        // trim: true,
      },
      offsetY: 0,
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      labels: {
        style: {
          colors: "#979797",
        },
      },
    },
    grid: {
      show: false, // ← REMOVES ALL GRID LINES
    },
    legend: {
      show: false, // ← REMOVES LEGEND (top text + color)
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: function (val) {
          return val + "%";
        },
      },
    },
    fill: {
      opacity: 1,
    },
  };

  return <Chart options={options} series={series} type="bar" height={290} />;
};
